import Customupload from '../../components/UploadFile'
import Style from './upload.module.scss'
import { HTTP } from '../../api/http'
import { RcFile } from 'antd/lib/upload'
import { message, Button } from 'antd'
import { Accept, download } from '../../tools/util'
import { UploadOutlined } from '@ant-design/icons'
import CustomIcon from '../../components/IconUser'
import { UPLOADFILE_PRODUCTION } from '../../api/uploadfileapi'
export interface fileFile {
  url: string
  baseUrl: string
  fileName: string
  fileId?: string
}

interface Props {
  dataSource: fileFile[]
  onChange: (e: fileFile[]) => void
  productCode?: string
  type?: '4' | '5'
  params?: { code: string; type: string }
  visible?: boolean
  fileNum?: number
}
// 上传文件
const Uploadfiles = (props: Props) => {
  const { dataSource, onChange, productCode, params, visible, fileNum } = props
  // 上传文件
  async function uploadfile(productCode: string, file: any) {
    const resData: any = await UPLOADFILE_PRODUCTION(file, params)
    if (resData.code === 0) {
      const data = resData.data
      message.success('上传成功')
      const newData = {
        url: data.newFilePath,
        fileName: data.filename,
        baseUrl: data.newFilePath,
      }
      onChange([newData])
    }
  }

  // 删除文件
  function onClickDel() {
    // const arr = dataSource.filter((item) => item.url !== index);
    onChange([])
  }

  // 下载文件
  function onClickDown(index: number) {
    // 获取下载路径
    const file = dataSource[index]
    const url = `${file.baseUrl ? file.baseUrl : HTTP}${file.url}`
    download(url)
  }

  // 上传之前处理文件
  function beforeUpload(file: RcFile) {
    const reg = new RegExp(
      /^.*(\.doc|\.docx|\.pdf|\.xlsx|\.xls|\.png|\.jpg|\.svg|\.jpeg)$/,
    )
    const index = file.name.search(reg)
    if (file.size > 1024 * 1024 * 20) {
      message.error('请勿上传超过20m的文件！')
      return false
    } else if (index === -1) {
      // 限制上传文件格式
      message.error('请上传正确的文件格式！')
      return false
    }
    uploadfile(productCode ? productCode : '', file)
    return false
  }

  return (
    <div className={Style.filebox}>
      {visible
        ? null
        : dataSource.map((item, index) => (
            <div className={Style.fileitem} key={index}>
              <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
              <span>{item.fileName}</span>
              <CustomIcon
                type="icon-shanchu1"
                onClick={() => onClickDel()}
                className={Style.delicon}
              />
              <Button
                size="small"
                type="link"
                style={{ fontSize: '12px' }}
                onClick={() => onClickDown(index)}
              >
                下载
              </Button>
            </div>
          ))}
      {dataSource.length < (fileNum ? fileNum : 1) ? (
        <Customupload
          accept={Accept('file')}
          uploadBtn={
            <Button
              type="default"
              size="small"
              style={{ margin: '0 0 10px 0' }}
            >
              <UploadOutlined /> 上传文件
            </Button>
          }
          beforeUpload={beforeUpload}
          visibleFile={false}
          multiple={false}
        />
      ) : null}
    </div>
  )
}

export default Uploadfiles
import Customupload from '../../components/UploadFile'
import Style from './upload.module.scss'
import { HTTP } from '../../api/http'
import { RcFile } from 'antd/lib/upload'
import { message, Button } from 'antd'
import { Accept, download } from '../../tools/util'
import { UploadOutlined } from '@ant-design/icons'
import CustomIcon from '../../components/IconUser'
import { UPLOADFILE_PRODUCTION } from '../../api/uploadfileapi'
export interface fileFile {
  url: string
  baseUrl: string
  fileName: string
  fileId?: string
}

interface Props {
  dataSource: fileFile[]
  onChange: (e: fileFile[]) => void
  productCode?: string
  type?: '4' | '5'
  params?: { code: string; type: string }
  visible?: boolean
  fileNum?: number
}
// 上传文件
const Uploadfiles = (props: Props) => {
  const { dataSource, onChange, productCode, params, visible, fileNum } = props
  // 上传文件
  async function uploadfile(productCode: string, file: any) {
    const resData: any = await UPLOADFILE_PRODUCTION(file, params)
    if (resData.code === 0) {
      const data = resData.data
      message.success('上传成功')
      const newData = {
        url: data.newFilePath,
        fileName: data.filename,
        baseUrl: data.newFilePath,
      }
      onChange([newData])
    }
  }

  // 删除文件
  function onClickDel() {
    // const arr = dataSource.filter((item) => item.url !== index);
    onChange([])
  }

  // 下载文件
  function onClickDown(index: number) {
    // 获取下载路径
    const file = dataSource[index]
    const url = `${file.baseUrl ? file.baseUrl : HTTP}${file.url}`
    download(url)
  }

  // 上传之前处理文件
  function beforeUpload(file: RcFile) {
    const reg = new RegExp(
      /^.*(\.doc|\.docx|\.pdf|\.xlsx|\.xls|\.png|\.jpg|\.svg|\.jpeg)$/,
    )
    const index = file.name.search(reg)
    if (file.size > 1024 * 1024 * 20) {
      message.error('请勿上传超过20m的文件！')
      return false
    } else if (index === -1) {
      // 限制上传文件格式
      message.error('请上传正确的文件格式！')
      return false
    }
    uploadfile(productCode ? productCode : '', file)
    return false
  }

  return (
    <div className={Style.filebox}>
      {visible
        ? null
        : dataSource.map((item, index) => (
            <div className={Style.fileitem} key={index}>
              <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
              <span>{item.fileName}</span>
              <CustomIcon
                type="icon-shanchu1"
                onClick={() => onClickDel()}
                className={Style.delicon}
              />
              <Button
                size="small"
                type="link"
                style={{ fontSize: '12px' }}
                onClick={() => onClickDown(index)}
              >
                下载
              </Button>
            </div>
          ))}
      {dataSource.length < (fileNum ? fileNum : 1) ? (
        <Customupload
          accept={Accept('file')}
          uploadBtn={
            <Button
              type="default"
              size="small"
              style={{ margin: '0 0 10px 0' }}
            >
              <UploadOutlined /> 上传文件
            </Button>
          }
          beforeUpload={beforeUpload}
          visibleFile={false}
          multiple={false}
        />
      ) : null}
    </div>
  )
}

export default Uploadfiles
